import React from 'react';
export var FormOptionsContext = React.createContext({
    labelCol: 8,
    wrapperCol: 16,
    validateTrigger: 'onChange',
    layout: 'horizontal',
});
//# sourceMappingURL=form-options-context.js.map